<ng-template #ccllBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('address.save-address-first' | translate)
                : ('address.missing-data-for-save' | translate)
        "
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="'address.save-address-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div #ccllBlock [blocked]="!model.id" [blockUi]="ccllBlockUi">
    @if (model.id) {
        <widget-address-contact-link-list
            #companyContactLinkList
            [autoFocusSearch]="false"
            [addInDialog]="true"
            [dialogEditMode]="true"
            [addInDetail]="false"
            [inlineEditMode]="false"
            [addressId]="model.id"
            [addressModelSig]="model"
        />
    }
</blockable-div>
